export enum PaymentIntent {
  PAYMENT_CURRENCY_EURO = 'price_1IpXPkL4O7UsyRO0R7bpZh5Z',
  PAYMENT_CURRENCY_SWISS = 'price_1IkWDzL4O7UsyRO0TkUwiJgQ',
}
